import { render } from "./processTransport.vue?vue&type=template&id=7044a568&scoped=true&ts=true"
import script from "./processTransport.vue?vue&type=script&lang=ts"
export * from "./processTransport.vue?vue&type=script&lang=ts"

import "./processTransport.vue?vue&type=style&index=0&id=7044a568&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7044a568"]])

export default __exports__